@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
                     [passportId]="passportId"></app-field-label>
    <div (click)="openAddressModal()"
         [id]="`editPassportAddAddressField[${fullValuePath}}`"
         class="d-flex align-items-end pointer"
         onkeypress="">
      <ix-input
        [disabled]="true"
        [ngClass]="{'invalid': errorInAddress}"
        [value]="addressValueCombined"
        class="w-100 pointer"
        id="{{ attribute.name }}">
        <ix-icon name="home" size="16" slot="start"></ix-icon>
        <ix-icon-button icon="pen" size="16" slot="end" variant="subtle-primary"></ix-icon-button>
      </ix-input>
    </div>
  </div>
}

<ng-template #addressModal let-modal>
  <ix-modal>
    <ix-modal-header icon="home">
      {{ 'battery_pass.edit.address_modal.headline' | translate }}
    </ix-modal-header>
    <ix-modal-content class="ms-0 ">
      <form>
        <ix-layout-grid class="px-0">
          @for (listAttribute of attribute.attributes; track listAttribute.valuePath) {
            <ix-row>
              <ix-col class="px-0 py-2" size="12">
                @switch (listAttribute.type) {
                  @case ('text') {
                    <app-text-input
                      [attribute]="listAttribute"
                      [passportId]="passportId"
                      [fullValuePath]="fullValuePath + '.' + listAttribute.valuePath"
                      [saveFunction]="saveFunction"
                      [passData]="getData(listAttribute.valuePath)"
                    />
                  }
                  @case ('number') {
                    <app-number-input
                      [attribute]="listAttribute"
                      [passportId]="passportId"
                      [fullValuePath]="fullValuePath + '.' + listAttribute.valuePath"
                      [saveFunction]="saveFunction"
                      [passData]="getData(listAttribute.valuePath)"
                    />
                  }
                  @case ('select') {
                    <app-select-input
                      [attribute]="listAttribute"
                      [passportId]="passportId"
                      [fullValuePath]="fullValuePath + '.' + listAttribute.valuePath"
                      [saveFunction]="saveFunction"
                      [passData]="getData(listAttribute.valuePath)"
                    />
                  }
                  @case ('document') {
                    <app-document-input
                      [attribute]="listAttribute"
                      [passportId]="passportId"
                      [fullValuePath]="fullValuePath + '.' + listAttribute.valuePath"
                      [saveFunction]="saveFunction"
                      [passData]="getData(listAttribute.valuePath)"
                    />
                  }
                  @case ('email') {
                    <app-email-input
                      [attribute]="listAttribute"
                      [passportId]="passportId"
                      [fullValuePath]="fullValuePath + '.' + listAttribute.valuePath"
                      [saveFunction]="saveFunction"
                      [passData]="getData(listAttribute.valuePath)"
                    />
                  }
                  @case ('boolean') {
                    <app-boolean-input
                      [attribute]="listAttribute"
                      [passportId]="passportId"
                      [fullValuePath]="fullValuePath + '.' + listAttribute.valuePath"
                      [saveFunction]="saveFunction"
                      [passData]="getData(listAttribute.valuePath)"
                    />
                  }
                  @default {
                    <ix-message-bar [persistent]="true" type="warning">
                      {{ 'battery_pass.edit.component_not_found' | translate: {type: listAttribute.type} }}
                    </ix-message-bar>
                  }
                }
              </ix-col>
            </ix-row>
          }
        </ix-layout-grid>
      </form>
    </ix-modal-content>
    <ix-modal-footer>
      <ix-button (click)="saveAddress(modal)" class="close-modal"
                 id="editPassportAddAddressSave"
                 onKeyPress=""
                 variant="primary">
        {{ 'general.ok' | translate }}
      </ix-button>
    </ix-modal-footer>
  </ix-modal>
</ng-template>
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
